import axios from '@/jslib/axios'

export const getOcrFileOption = params => {
  return axios({
    method: 'get',
    url: '/admin/ocr/file/option',
    params
  })
}
export const getOcrAsyncData = params => {
  return axios({
    method: 'get',
    url: '/admin/ocr/async',
    params
  })
}
export const ocrFileDetail = data => {
  return axios({
    method: 'post',
    url: '/admin/ocr',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
    timeout: 120000
  })
}